import { useEffect, useMemo, useRef, useState } from 'react';
import CommandesTab from './components/CommandesTab';
import BiensTab from './components/BiensTab';
import CuisineTab from './components/CuisineTab';
import PlatsMenuTab from './components/PlatsMenuTab';
import IngredientsTab from './components/IngredientsTab';
import SupplyTab from './components/SupplyTab';
import StockTab from './components/StockTab';
import StockAdjustmentTab from './components/StockAdjustmentTab';
import SuppliersComparisonTab from './components/SuppliersComparison';
import TablesTab from './components/TablesTab';
import UnitsTab from './components/UnitsTab';
import SuppliersTab from './components/SuppliersTab';
import ProductTypesTab from './components/ProductTypesTab';
import RecipesTab from './components/RecipesTab';
import BatchesTab from './components/BatchesTab';
import RecipeVersionsTab from './components/RecipeVersionsTab';
import SalesHistoryTab from './components/SalesHistoryTab';
import SalesOverviewTab from './components/SalesOverviewTab';
import SalesReportTab from './components/SalesReport';
import BiensCategoriesTab from './components/BiensCategoriesTab';
import ParametersTab from './components/ParametersTab';
import ImportTab from './components/ImportTab';
import IngredientInventoriesTab from './components/IngredientInventoriesTab';
import ConsumablesTab from './components/ConsumablesTab';
import StockOutputTab from './components/StockOutputTab';
import StockTrendsTab from './components/StockTrendsTab';


// ────────────────────────────────────────────────────────────────────────────
// Icônes (SVG inline, sans dépendance externe) — un trait visuel simple par
// onglet pour que chaque section soit reconnaissable au premier coup d'œil.
// ────────────────────────────────────────────────────────────────────────────
const ICON_PATHS = {
    commandes: 'M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v0Z M9 12h6M9 16h6',
    cuisine: 'M12 3c1 2-1 3-1 5a3 3 0 0 0 6 0c0-1-.5-2-1-3 1.5 1 3 3.5 3 6a6 6 0 1 1-12 0c0-2.5 2-4.5 3-5 0 1.5-.5 2.5-1 3.5',
    salesHistory: 'M12 8v4l3 2M21 12a9 9 0 1 1-3.5-7.1M21 4v5h-5',
    salesReport: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
    supply: 'M3 7h11v9H3V7Zm11 3h3l3 3v3h-6v-6ZM6.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm12 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
    stock: 'M3 7l9-4 9 4-9 4-9-4Zm0 0v10l9 4 9-4V7M12 11v10',
    suppliersComparison: 'M12 3v18M7 8l-4 4 4 4M17 8l4 4-4 4M5 12h6m2 0h6',
    stockOutput: 'M12 19V5M6 11l6-6 6 6M4 21h16',
    stockTrends: 'M3 17l6-6 4 4 8-8M15 7h6v6',
    dailyPayments: 'M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6',
    ingredientInventories: 'M9 5h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Zm0-2h6v2H9V3Zm-.5 8.5 1.5 1.5 3-3',
    biens: 'M4 21V9l8-6 8 6v12M9 21v-6h6v6M4 21h16',
    parametres: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7.4-3a7.4 7.4 0 0 0-.14-1.4l2.1-1.6-2-3.4-2.5 1a7.4 7.4 0 0 0-2.4-1.4L14 2h-4l-.46 2.6a7.4 7.4 0 0 0-2.4 1.4l-2.5-1-2 3.4 2.1 1.6a7.4 7.4 0 0 0 0 2.8l-2.1 1.6 2 3.4 2.5-1a7.4 7.4 0 0 0 2.4 1.4L10 22h4l.46-2.6a7.4 7.4 0 0 0 2.4-1.4l2.5 1 2-3.4-2.1-1.6c.1-.46.14-.93.14-1.4Z',
    plats: 'M7 2v6a2 2 0 0 0 2 2v12M7 2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2M11 2v20M17 2c-2 0-3 2-3 5s1 4 3 4v9',
    ingredients: 'M12 3c4 0 7 3 7 7 0 6-5 10-7 11-2-1-7-5-7-11 0-4 3-7 7-7Zm0 4v6',
    consumables: 'M4 8l8-5 8 5-8 5-8-5Zm0 0v9l8 5 8-5V8M12 13v9',
    units: 'M3 17V7h18v10H3Zm3-10v3m3-3v5m3-5v3m3-3v5m3-5v3',
    suppliers: 'M17 20v-1a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v1M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm10 9v-1a3.5 3.5 0 0 0-2.5-3.4M15 4.2a3 3 0 0 1 0 5.6',
    productTypes: 'M20.5 12.6 12 21l-9-9 8.5-8.4H20v8ZM12.5 8.5h.01',
};

function NavIcon({ name, className = 'w-5 h-5' }) {
    const d = ICON_PATHS[name];
    if (!d) return null;
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            <path d={d} />
        </svg>
    );
}

// ────────────────────────────────────────────────────────────────────────────
// Menu de navigation principal — regroupé par thème pour qu'on distingue tout
// de suite « qui fait quoi » : Service, Ventes, Achats & Stock, Gestion.
// ────────────────────────────────────────────────────────────────────────────
const navGroups = [
    {
        label: 'Service',
        tabs: [
            { key: 'commandes', label: 'Commandes' },
            { key: 'cuisine', label: 'Cuisine' },
        ],
    },
    {
        label: 'Ventes',
        tabs: [
            { key: 'salesHistory', label: 'Historique des ventes' },
            { key: 'dailyPayments', label: 'Ventes & paiements' },
            { key: 'salesReport', label: 'Rapport ventes' },
        ],
    },
    {
        label: 'Achats & Stock',
        tabs: [
            { key: 'supply', label: 'Approvisionnement' },
            { key: 'stock', label: 'Stock' },
            { key: 'stockOutput', label: 'Sortie stock' },
            { key: 'stockAdjustment', label: 'Ajustement stock' },
            { key: 'stockTrends', label: 'Tendances stock' },
            { key: 'suppliersComparison', label: 'Comparaison fournisseurs' },
            { key: 'ingredientInventories', label: 'Inventaire ingrédients' },
        ],
    },
    {
        label: 'Gestion',
        tabs: [
            { key: 'biens', label: 'Biens' },
            { key: 'parametres', label: 'Paramètres' },
        ],
    },
];

// Liste plate dérivée des groupes ci-dessus (utilisée pour les permissions par rôle)
const tabs = navGroups.flatMap((group) => group.tabs);

const pathToTab = {
    '/commandes': 'commandes',
    '/cuisine': 'cuisine',
    '/plats': 'plats',
    '/ingredients': 'ingredients',
    '/units': 'units',
    '/suppliers': 'suppliers',
    '/supply': 'supply',
    '/stock': 'stock',
    '/suppliers-comparison': 'suppliersComparison',
    '/stock-output': 'stockOutput',
    '/stock-adjustment': 'stockAdjustment',
    '/stock-trends': 'stockTrends',
    '/daily-payments': 'dailyPayments',
    '/inventaire': 'stock',
    // components tab removed
    '/recipes': 'recipes',
    '/product-types': 'productTypes',
    '/sales-history': 'salesHistory',
    '/sales-report': 'salesReport',
    '/biens-categories': 'biensCategories',
    '/parametres': 'parametres',
    '/tables': 'tables',
    '/biens': 'biens',
    '/ingredient-inventories': 'ingredientInventories',
    '/consumables': 'consumables',
    '/import': 'import',
    '/recipe-versions': 'recipeVersions',
};

const resolveTabFromPath = (path = '') => {
    const normalizedPath = (path || '').toLowerCase().replace(/\/$/, '');
    if (normalizedPath.startsWith('/ingredient-inventories')) {
        return 'ingredientInventories';
    }
    return pathToTab[normalizedPath] || (normalizedPath.startsWith('/biens') ? 'biens' : 'commandes');
};

const tabToPath = Object.fromEntries(Object.entries(pathToTab).map(([path, tab]) => [tab, path]));

const initialIngredients = [];
const initialMenuItems = [];
const initialTables = [];
const initialMovements = [];
const initialSupplyOrders = [];

const parseNumericValue = (value) => {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    if (typeof value === 'string') {
        const trimmed = String(value).trim();
        if (!trimmed) return null;
        const normalized = trimmed.replace(/[\s\u202f]/g, '');

        if (normalized.includes(',') && normalized.includes('.')) {
            // French style with thousands separators and comma decimal, e.g. 1.234,56
            return Number(normalized.replace(/\./g, '').replace(',', '.'));
        }
        if (normalized.includes(',')) {
            return Number(normalized.replace(',', '.'));
        }
        return Number(normalized);
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};

const fetchJson = async (url, options = {}) => {
    const method = (options.method || 'GET').toUpperCase();
    const headers = {
        Accept: 'application/json',
        ...(options.headers || {}),
    };

    if (method !== 'GET' && !Object.keys(headers).some((key) => key.toLowerCase() === 'content-type')) {
        headers['Content-Type'] = 'application/json';
    }

    let response;
    try {
        response = await fetch(url, {
            credentials: 'same-origin',
            headers,
            ...options,
        });
    } catch (error) {
        const networkError = new Error(`Network error while fetching ${url}: ${error.message}`);
        networkError.cause = error;
        throw networkError;
    }

    if (response.status === 401 || response.status === 419) {
        redirectToLogin();
        const error = new Error('Session expirée');
        error.status = response.status;
        throw error;
    }

    const bodyText = await response.text();

    if (!response.ok) {
        let parsed = null;
        try {
            parsed = JSON.parse(bodyText);
        } catch (e) {
            // ignore parse error
        }
        const message = parsed?.message || `${response.status} ${response.statusText}: ${bodyText}`;
        const error = new Error(message);
        error.status = response.status;
        error.body = bodyText;
        throw error;
    }

    try {
        return bodyText ? JSON.parse(bodyText) : null;
    } catch (e) {
        return null;
    }
};

const redirectToLogin = () => {
    window.location.href = '/login';
};

const verifySession = async () => {
    try {
        const response = await fetch('/api/user', {
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
        });

        if (response.status === 204 || response.status === 401 || response.status === 419) {
            redirectToLogin();
            return false;
        }
    } catch (error) {
        console.error('Erreur de vérification de session :', error);
    }
    return true;
};

const refreshSession = async () => {
    try {
        const response = await fetch('/api/refresh-session', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
        });

        if (response.status === 401 || response.status === 419) {
            redirectToLogin();
            return false;
        }
        return response.ok;
    } catch (error) {
        console.error('Erreur de renouvellement de session :', error);
        return false;
    }
};

const handleLogout = async () => {
    try {
        await fetch('/logout', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            },
        });
    } catch (error) {
        console.error('Logout error:', error);
    } finally {
        redirectToLogin();
    }
};

const normalizeIngredient = (ingredient) => ({
    id: ingredient.id,
    name: ingredient.name,
    stock: Number(ingredient.calculated_stock ?? ingredient.stock_quantity ?? 0),
    item_type: ingredient.item_type || 'ingredient',
    stock_quantity: Number(ingredient.stock_quantity ?? 0),
    threshold: Number(ingredient.min_stock_alert || 0),
    marque: ingredient.marque || '',
    caracteristique: ingredient.caracteristique || '',
    category: ingredient.category || null,
    unit: ingredient.unit?.name || 'unité',
    unit_id: ingredient.unit?.id || 1,
    purchasePrice: Number(ingredient.cost_per_unit || 0),
    last_price: Number(ingredient.last_price ?? ingredient.lastPrice ?? ingredient.purchasePrice ?? ingredient.cost_per_unit ?? ingredient.purchase_price ?? 0),
    last_price_source: ingredient.last_price_source || null,
    supplier: ingredient.supplier || '',
    purchaseDate: ingredient.purchase_date || '',
    perishable: ingredient.perishable ?? false,
    expirationDate: ingredient.expiration_date || '',
});

const normalizeDish = (dish) => {
    const recipeSource = dish.dishIngredients || dish.dish_ingredients || dish.ingredients || [];

    return {
        id: dish.id,
        name: dish.name,
        number: dish.number != null ? Number(dish.number) : null,
        category: dish.category?.name || dish.dish_category?.name || dish.dishCategory?.name || null,
        dish_category_id: dish.dish_category_id || dish.dishCategory?.id || null,
        price: Number(dish.price || 0),
        material_cost: Number(dish.material_cost || dish.materialCost || 0),
        labor_charges: Number(dish.labor_charges || dish.laborCharges || 0),
        // components removed; dishes are ingredient-only
        is_component: false,
        recipe: (Array.isArray(recipeSource) ? recipeSource : []).map((item) => {
            const type = item.source_type || item.type || (item.component || item.component_id ? 'component' : 'ingredient');
            const normalizedType = type === 'decoration' ? 'decoration' : type;
            const componentId = normalizedType === 'component'
                ? Number(item.component?.id || item.component_id || item.component || 0)
                : null;
            const ingredientId = normalizedType === 'component'
                ? null
                : Number(item.ingredient?.id || item.ingredient_id || item.id || 0);

            // Store component/ingredient object for display
            const itemObject = normalizedType === 'component' ? item.component : item.ingredient;
            const itemName = itemObject?.name || '';
            const itemMarque = itemObject?.marque || '';
            const itemCaracteristique = itemObject?.caracteristique || '';

            return {
                ingredientId,
                componentId,
                type: normalizedType,
                qty: Number(item.pivot?.quantity || item.quantity || item.qty || 0),
                unitId: item.pivot?.unit_id || item.unit_id || item.unitId || null,
                notes: item.pivot?.notes || item.notes || '',
                // Store metadata for display and calculations
                itemName,
                itemMarque,
                itemCaracteristique,
                itemObject: itemObject || {},
            };
        }),
        is_active: dish.is_active,
        status: dish.status,
    };
};

const normalizeTable = (table) => {
    const activeOrder = table.order || table.activeOrder;
    return {
        id: table.id,
        name: table.name || table.number,
        number: table.number,
        capacity: table.capacity,
        zone_id: table.zone_id ?? table.zone?.id ?? null,
        zone: table.zone,
        status: table.status,
        is_active: table.is_active,
        qr_code: table.qr_code,
        order: activeOrder
            ? {
                  id: activeOrder.id,
                  status: activeOrder.status,
                  notes: activeOrder.notes,
                  items: (activeOrder.items || []).map((item) => ({
                      menuItemId: item.menuItemId || item.dish_id || item.dishId || null,
                      quantity: item.quantity,
                      notes: item.notes || item.note || null,
                      name: item.name || item.menuItemName || item.dish_name || item.dishName || null,
                  })),
              }
            : null,
    };
};

const normalizeTicket = (ticket) => ({
    id: ticket.id,
    tableId: ticket.order?.table?.id || ticket.table_id || ticket.tableId || null,
    tableName: ticket.order?.table?.name || ticket.tableName || 'Table',
    status: ticket.status,
    createdAt: ticket.created_at || ticket.createdAt,
    items: (ticket.items || []).map((item) => ({
        menuItemId: item.order_item?.dish_id || item.orderItem?.dish_id || item.dish_id,
        quantity: item.order_item?.quantity || item.orderItem?.quantity || item.quantity || 1,
        ready: item.order_item?.status === 'ready' || item.orderItem?.status === 'ready' || false,
    })),
});

const normalizeSupplyOrder = (order) => ({
    id: order.id,
    item_type: order.item_type || order.itemType || 'ingredient',
    item_name: order.item_name || order.itemName || '',
    target_id: order.target_id || order.targetId || order.ingredient_id || order.ingredientId || order.item_id || order.itemId || null,
    service: order.service || null,
    lot_number: order.lot_number || order.lotNumber || null,
    quantity: Number(order.quantity || 0),
    received_quantity: Number(order.received_quantity || order.receivedQuantity || 0),
    unit: order.unit || '',
    unit_id: order.unit_id || null,
    purchase_price: Number(order.purchase_price || order.purchasePrice || 0),
    supplier: typeof order.supplier === 'string'
        ? order.supplier
        : order.supplier?.companyName || order.supplier?.company_name || '',
    order_date: order.order_date || order.orderDate || null,
    purchase_date: order.purchase_date || order.purchaseDate || null,
    expected_delivery_date: order.expected_delivery_date || order.expectedDeliveryDate || null,
    actual_delivery_date: order.actual_delivery_date || order.actualDeliveryDate || null,
    perishable: order.perishable ?? false,
    expiration_date: order.expiration_date || order.expirationDate || null,
    status: order.status || order.order_status || 'commandé',
    user_id: order.user_id || null,
    created_at: order.created_at || null,
    updated_at: order.updated_at || null,
});

const ensureArray = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === 'object' && value.data && Array.isArray(value.data)) return value.data;
    if (typeof value === 'object') return Object.values(value);
    return [];
};

function generateId(list) {
    return list.length ? Math.max(...list.map((item) => item.id)) + 1 : 1;
}

function App() {
    const [activeTab, setActiveTab] = useState(() => resolveTabFromPath(window.location.pathname));
    const [sidebarOpen, setSidebarOpen] = useState(() => (typeof window !== 'undefined' ? window.innerWidth >= 1024 : true));
    const [user, setUser] = useState(null);
    const sessionCheckTimeRef = useRef(0);

    const parameterSubTabs = [
        { key: 'plats', label: 'Plats & Menu', icon: 'plats' },

        { key: 'ingredients', label: 'Ingrédients', icon: 'ingredients' },
        { key: 'consumables', label: 'Consommables', icon: 'consumables' },
        { key: 'units', label: 'Unités', icon: 'units' },
        { key: 'suppliers', label: 'Fournisseurs', icon: 'suppliers' },
        { key: 'productTypes', label: 'Types de produit', icon: 'productTypes' },
        { key: 'ingredients', label: 'Ingrédients', icon: 'ingredients' },
        { key: 'tables', label: 'Tables', icon: 'tables' },
        { key: 'zones', label: 'Zones', icon: 'zones' }
    ];

    // Ferme automatiquement le tiroir de navigation quand on repasse en desktop,
    // et l'ouvre par défaut ; sur mobile/tablette il reste fermé par défaut.
    useEffect(() => {
        const onResize = () => {
            setSidebarOpen(window.innerWidth >= 1024);
        };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    // Navigation : on référence dans l'historique + on referme le tiroir sur mobile
    // après avoir choisi un onglet, pour ne pas masquer le contenu.
    const navigateTab = (tabKey) => {
        if (tabKey !== activeTab && tabToPath[tabKey]) {
            window.history.pushState({ tab: tabKey }, '', tabToPath[tabKey]);
        }

        setActiveTab(tabKey);

        if (typeof window !== 'undefined' && window.innerWidth < 1024) {
            setSidebarOpen(false);
        }
    };

    const verifySession = async () => {
        try {
            // Vérifier et renouveler la session en une seule requête
            const response = await fetch('/api/refresh-session', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
            });
            if (response.status === 204 || response.status === 401 || response.status === 419 || !response.ok) {
                redirectToLogin();
                return false;
            }
            return true;
        } catch (error) {
            console.error('Erreur de vérification de session :', error);
            return true;
        }
    };

    const loadAppData = async () => {
        try {
            const [ingredientResponse, consumableResponse, dishResponse, unitResponse, tableResponse, ticketResponse, movementResponse, supplyResponse, supplierResponse, productTypesResponse, dishCategoriesResponse] = await Promise.all([
                fetchJson('/api/inventory/ingredients').catch((error) => {
                    console.error('Impossible de charger les ingrédients :', error);
                    return [];
                }),
                fetchJson('/api/inventory/consumables').catch((error) => {
                    console.error('Impossible de charger les consommables :', error);
                    return [];
                }),
                fetchJson('/api/inventory/dishes').catch((error) => {
                    console.error('Impossible de charger les plats :', error);
                    return [];
                }),
                fetchJson('/api/inventory/units').catch((error) => {
                    console.error('Impossible de charger les unités :', error);
                    return [];
                }),
                fetchJson('/api/tables').catch((error) => {
                    console.error('Impossible de charger les tables :', error);
                    return [];
                }),
                fetchJson('/api/kitchen/tickets').catch((error) => {
                    console.error('Impossible de charger les tickets :', error);
                    return [];
                }),
                fetchJson('/api/inventory/movements?per_page=500').catch((error) => {
                    console.error('Impossible de charger les mouvements :', error);
                    return [];
                }),
                fetchJson('/api/supply/orders').catch((error) => {
                    console.error('Impossible de charger les commandes d’approvisionnement :', error);
                    return [];
                }),
                fetchJson('/api/suppliers').catch((error) => {
                    console.error('Impossible de charger les fournisseurs :', error);
                    return [];
                }),
                fetchJson('/api/product-types').catch((error) => {
                    console.error('Impossible de charger les types de produit :', error);
                    return [];
                }),
                fetchJson('/api/inventory/dish-categories').catch((error) => {
                    console.error('Impossible de charger les catégories de plats :', error);
                    return [];
                }),
            ]);

            const normalizedIngredients = ensureArray(ingredientResponse)
                .map(normalizeIngredient)
                .filter((item) => item.item_type !== 'consumable');

            setIngredients(normalizedIngredients);
            setConsumables(ensureArray(consumableResponse));
            setMenuItems(ensureArray(dishResponse).map(normalizeDish));
            setUnits(ensureArray(unitResponse));
            setTables(ensureArray(tableResponse).map(normalizeTable));
            setTickets(ensureArray(ticketResponse).map(normalizeTicket));
            setMovements(ensureArray(movementResponse));
            setSupplyOrders(ensureArray(supplyResponse).map(normalizeSupplyOrder));
            setSuppliers(ensureArray(supplierResponse));
            setProductTypes(ensureArray(productTypesResponse));
            setDishCategories(ensureArray(dishCategoriesResponse));
        } catch (error) {
            console.error("Impossible de charger les données depuis l'API :", error);
        }
    };
    const [isUserLoaded, setIsUserLoaded] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [visibleTabs, setVisibleTabs] = useState([]);
    const [ingredients, setIngredients] = useState(initialIngredients);
    const [consumables, setConsumables] = useState([]);
    const [menuItems, setMenuItems] = useState(initialMenuItems);
    const [tables, setTables] = useState(initialTables);
    const [tickets, setTickets] = useState([]);
    const [movements, setMovements] = useState(initialMovements);
    const [supplyOrders, setSupplyOrders] = useState(initialSupplyOrders);
    const [units, setUnits] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [productTypes, setProductTypes] = useState([]);
    const [dishCategories, setDishCategories] = useState([]);

    useEffect(() => {
        const initApp = async () => {
            try {
                const userResp = await fetch('/api/user', { credentials: 'same-origin', headers: { 'Content-Type': 'application/json' } });
                if (userResp.status === 204 || userResp.status === 401 || userResp.status === 419) {
                    redirectToLogin();
                    return;
                }

                if (userResp.ok) {
                    const u = await userResp.json();
                    setUser(u);
                } else {
                    console.error(`Impossible de récupérer l’utilisateur : statut ${userResp.status}`);
                    return;
                }
            } catch (error) {
                console.error('Impossible de récupérer l’utilisateur :', error);
                return;
            } finally {
                setIsUserLoaded(true);
            }

            await loadAppData();
        };

        initApp();
    }, []);

    useEffect(() => {
        if (!isUserLoaded || !user) return;

        const interval = setInterval(async () => {
            try {
                const [ingredientResponse, dishResponse] = await Promise.all([
                    fetchJson('/api/inventory/ingredients'),
                    fetchJson('/api/inventory/dishes'),
                ]);

                const normalizedIngredients = ensureArray(ingredientResponse)
                    .map(normalizeIngredient)
                    .filter((item) => item.item_type !== 'consumable');

                setIngredients(normalizedIngredients);
                setMenuItems(ensureArray(dishResponse).map(normalizeDish));
            } catch (error) {
                console.error('Erreur de rafraîchissement automatique des ingrédients/plats :', error);
            }
        }, 30000);

        return () => clearInterval(interval);
    }, [isUserLoaded, user]);

    useEffect(() => {
        const onUserInteraction = async () => {
            if (!user || !isUserLoaded) return;
            const now = Date.now();
            if (now - sessionCheckTimeRef.current < 10000) return;
            sessionCheckTimeRef.current = now;
            await verifySession();
        };

        document.addEventListener('click', onUserInteraction);
        document.addEventListener('keydown', onUserInteraction);
        return () => {
            document.removeEventListener('click', onUserInteraction);
            document.removeEventListener('keydown', onUserInteraction);
        };
    }, [user, isUserLoaded]);

    // Renouvellement automatique de la session toutes les 20 minutes
    useEffect(() => {
        if (!isUserLoaded || !user) return;

        const sessionRefreshInterval = setInterval(async () => {
            await refreshSession();
        }, 20 * 60 * 1000); // 20 minutes

        return () => clearInterval(sessionRefreshInterval);
    }, [isUserLoaded, user]);

    useEffect(() => {
        const onPopState = (event) => {
            const tabKey = event.state?.tab;
            if (tabKey) {
                setActiveTab(tabKey);
                return;
            }
            const routedTab = resolveTabFromPath(window.location.pathname);
            setActiveTab(routedTab);
        };

        const initialPath = tabToPath[activeTab] || window.location.pathname;
        window.history.replaceState({ tab: activeTab }, '', initialPath);
        window.history.pushState({ tab: activeTab }, '', initialPath);
        window.addEventListener('popstate', onPopState);
        return () => window.removeEventListener('popstate', onPopState);
    }, []);

    const ingredientMap = useMemo(
        () => new Map(ingredients.map((item) => [item.id, item])),
        [ingredients]
    );

    const supplierMap = useMemo(
        () => new Map(suppliers.map((item) => [item.id, item])),
        [suppliers]
    );

    // Mettre à jour les onglets visibles selon le rôle
    useEffect(() => {
        if (!isUserLoaded) return;
        if (!user) {
            setVisibleTabs([]);
            return;
        }

        const role = user.role?.name?.toLowerCase() || '';
        if (['admin', 'manager', 'direction'].includes(role)) {
            setVisibleTabs(tabs);
            return;
        }

        if (role === 'cashier') {
            setVisibleTabs(tabs.filter((t) => ['commandes', 'salesHistory', 'dailyPayments', 'salesReport'].includes(t.key)));
            return;
        }

        if (['kitchen', 'barman'].includes(role)) {
            setVisibleTabs(tabs.filter((t) => ['commandes', 'cuisine', 'stock', 'stockOutput', 'stockTrends'].includes(t.key)));
            return;
        }

        // Par défaut, aucun onglet
        setVisibleTabs([]);
    }, [user, isUserLoaded]);

    // Si l'onglet actif n'est pas visible, basculer sur le premier visible
    useEffect(() => {
        if (!visibleTabs || visibleTabs.length === 0) return;
        if (!visibleTabs.find((t) => t.key === activeTab)) {
            setActiveTab(visibleTabs[0].key);
        }
    }, [visibleTabs]);

    // Groupes de navigation filtrés selon les onglets réellement visibles pour
    // le rôle courant (on ne garde que les groupes qui ont au moins un onglet).
    const visibleNavGroups = useMemo(() => {
        const visibleKeys = new Set(visibleTabs.map((t) => t.key));
        return navGroups
            .map((group) => ({
                ...group,
                tabs: group.tabs.filter((t) => visibleKeys.has(t.key)),
            }))
            .filter((group) => group.tabs.length > 0);
    }, [visibleTabs]);

    const getPortionsRemaining = (menuItem) => {
        if (!menuItem?.recipe?.length) return null;
        return menuItem.recipe.reduce((acc, step) => {
            const ingredient = ingredientMap.get(step.ingredientId);
            if (!ingredient || step.qty <= 0) return acc;
            const maxPortions = Math.floor(ingredient.stock / step.qty);
            return acc === null ? maxPortions : Math.min(acc, maxPortions);
        }, null);
    };

    const updateTable = (tableId, changes) => {
        setTables((prev) =>
            prev.map((table) => (table.id === tableId ? { ...table, ...changes } : table))
        );
    };

    const updateTableOrder = (tableId, order) => {
        setTables((prev) =>
            prev.map((table) => (table.id === tableId ? { ...table, order } : table))
        );
    };

    const sendOrderToKitchen = async (tableId) => {
        const table = tables.find((item) => item.id === tableId);
        if (!table?.order || !table.order.items?.length) return;

        try {
            let order = table.order;
            if (!order.id) {
                const items = order.items.map((item) => ({
                    dish_id: item.menuItemId,
                    quantity: item.quantity,
                    notes: item.notes || null,
                }));

                const createdOrder = await fetchJson('/api/orders', {
                    method: 'POST',
                    body: JSON.stringify({
                        table_id: table.id,
                        type: 'dine_in',
                        covers: order.covers || 1,
                        notes: order.notes || null,
                        items,
                    }),
                });

                order = {
                    ...order,
                    ...createdOrder,
                    status: createdOrder.status || 'ready',
                    orderedAt: createdOrder.ordered_at || createdOrder.orderedAt || new Date().toISOString(),
                    items: createdOrder.items || order.items || [],
                };
            } else {
                const updatedOrder = await fetchJson(`/api/orders/${order.id}`, {
                    method: 'PUT',
                    body: JSON.stringify({ status: 'ready' }),
                });

                order = {
                    ...order,
                    ...updatedOrder,
                    status: updatedOrder.status || 'ready',
                    orderedAt: updatedOrder.ordered_at || updatedOrder.orderedAt || order.orderedAt || new Date().toISOString(),
                };
            }

            updateTableOrder(tableId, order);
            updateTable(tableId, { status: 'occupied' });
        } catch (error) {
            console.error('Erreur lors de la commande :', error);
            alert(error.message || 'Impossible de passer la commande.');
        }
    };

    const payOrder = async (tableId, paymentData) => {
        const table = tables.find((table) => table.id === tableId);
        if (!table?.order?.id) return;

        let paymentResponse;
        try {
            paymentResponse = await fetchJson(`/api/orders/${table.order.id}/pay`, {
                method: 'POST',
                body: JSON.stringify({
                    payment_method: paymentData.paymentMethod,
                    amount_received: paymentData.amountReceived,
                    payment_reference: paymentData.paymentReference,
                }),
            });
        } catch (error) {
            console.error('Erreur lors du paiement :', error);
            alert(error.message || 'Impossible d’enregistrer le paiement.');
            throw error;
        }

        setTables((prev) =>
            prev.map((table) => {
                if (table.id !== tableId || !table.order) return table;

                return {
                    ...table,
                    status: 'available',
                    order: null,
                };
            })
        );

        return paymentResponse;
    };

    const markOrderAsServed = async (tableId) => {
        const table = tables.find((table) => table.id === tableId);
        if (!table?.order?.id) return;

        try {
            const response = await fetchJson(`/api/orders/${table.order.id}`, {
                method: 'PUT',
                body: JSON.stringify({ status: 'served' }),
            });

            updateTableOrder(tableId, { ...table.order, status: 'served' });
            return response;
        } catch (error) {
            console.error('Erreur lors de la mise à jour du statut :', error);
            alert(error.message || 'Impossible de marquer la commande comme servie.');
            throw error;
        }
    };

    const updateTicket = (ticketId, changes) => {
        const ticket = tickets.find((item) => item.id === ticketId);
        setTickets((prev) =>
            prev.map((ticket) => (ticket.id === ticketId ? { ...ticket, ...changes } : ticket))
        );

        if (!ticket) return;

        if (changes.status === 'ready') {
            const table = tables.find((item) => item.id === ticket.tableId);
            if (table?.order) {
                updateTableOrder(ticket.tableId, {
                    ...table.order,
                    status: 'ready',
                    readyAt: changes.completedAt || new Date().toISOString(),
                });
            }
        }
    };

    const consumeTicketStock = (ticketId) => {
        const ticket = tickets.find((item) => item.id === ticketId);
        if (!ticket || ticket.consumed) return;

        const consumption = ticket.items.reduce((map, item) => {
            const menu = menuItems.find((menuItem) => menuItem.id === item.menuItemId);
            menu?.recipe.forEach(({ ingredientId, qty }) => {
                const current = map.get(ingredientId) ?? 0;
                map.set(ingredientId, current + qty * item.quantity);
            });
            return map;
        }, new Map());

        setIngredients((prev) =>
            prev.map((ingredient) => {
                const consumedQty = consumption.get(ingredient.id) ?? 0;
                return consumedQty ? { ...ingredient, stock: Math.max(0, ingredient.stock - consumedQty) } : ingredient;
            })
        );

        const movementDate = new Date().toISOString().slice(0, 10);
        setMovements((prev) => {
            let nextId = generateId(prev);
            return [
                ...prev,
                ...Array.from(consumption.entries()).map(([ingredientId, quantity]) => ({
                    id: nextId++,
                    type: 'Consommation',
                    stockable_id: ingredientId,
                    stockable_type: 'ingredient',
                    item: `Ticket #${ticket.id}`,
                    quantity: -quantity,
                    date: movementDate,
                    reference: `Ticket #${ticket.id}`,
                    note: `Consommation sur ticket ${ticket.id}`,
                })),
            ];
        });

        updateTicket(ticketId, { consumed: true });
    };

    const getUnitName = (unitId) => units.find((unit) => unit.id === Number(unitId))?.name || '';

    const findSupplierByName = (name) => {
        if (!name?.trim()) return null;
        const normalizedName = name.trim().toLowerCase();
        return suppliers.find((supplier) => {
            const supplierName = (supplier.companyName || supplier.name || '').trim().toLowerCase();
            return supplierName === normalizedName;
        }) || null;
    };

    const createSupplier = async (supplierName) => {
        if (!supplierName?.trim()) return null;
        const existing = findSupplierByName(supplierName);
        if (existing) return existing;

        const newSupplier = await fetchJson('/api/suppliers', {
            method: 'POST',
            body: JSON.stringify({ companyName: supplierName.trim() }),
        });

        setSuppliers((prev) => [...prev, newSupplier]);
        return newSupplier;
    };
    const normalizeSupplyStatus = (status) => {
        const value = String(status || '').trim().toLowerCase();
        const normalized = {
            brouillon: 'brouillon',
            commande: 'commandé',
            commandé: 'commandé',
            'en transit': 'en transit',
            en_transit: 'en transit',
            livré: 'livré',
            livre: 'livré',
            reçu: 'reçu',
            recu: 'reçu',
            annulé: 'annulé',
            annule: 'annulé',
        }[value];
        return normalized || (value || 'commandé');
    };

    const normalizeSupplyOrder = (order) => ({
        ...order,
        receivedQuantity: parseNumericValue(order.receivedQuantity ?? order.received_quantity ?? 0) ?? 0,
        purchasePrice: parseNumericValue(order.purchasePrice ?? order.purchase_price ?? 0) ?? 0,
        quantity: parseNumericValue(order.quantity ?? 0) ?? 0,
        itemName: order.itemName || order.item_name || '',
        targetId: Number(order.targetId ?? order.target_id ?? 0) || null,
        lotNumber: order.lotNumber || order.lot_number || null,
        supplierId: Number(order.supplierId ?? order.supplier_id ?? order.supplierID ?? 0) || null,
        supplier: order.supplier && typeof order.supplier === 'object'
            ? String(order.supplier.companyName || order.supplier.company_name || order.supplier.name || order.supplier.supplier_name || order.supplier.label || '')
            : String(order.supplier || order.supplier_name || order.companyName || order.company_name || order.provider || ''),
        unit_id: order.unit_id ?? null,
        unit: order.unit || '',
        orderDate: order.orderDate || order.order_date || null,
        purchaseDate: order.purchaseDate || order.purchase_date || null,
        expectedDeliveryDate: order.expectedDeliveryDate || order.expected_delivery_date || null,
        actualDeliveryDate: order.actualDeliveryDate || order.actual_delivery_date || null,
        perishable: order.perishable ?? false,
        expirationDate: order.expirationDate || order.expiration_date || null,
        status: normalizeSupplyStatus(order.status || order.order_status || order.state || order.statut || 'commandé'),
        itemType: order.itemType || order.item_type || (Number(order.targetId ?? order.target_id) > 0 ? 'ingredient' : 'dish'),
        validatedByUserId: order.validatedByUserId ?? order.validated_by_user_id ?? null,
        validatedByUserName: order.validatedByUserName ?? order.validated_by_user_name ?? null,
        validatedAt: order.validatedAt ?? order.validated_at ?? null,
        receivedByUserId: order.receivedByUserId ?? order.received_by_user_id ?? null,
        receivedByUserName: order.receivedByUserName ?? order.received_by_user_name ?? null,
        receivedAt: order.receivedAt ?? order.received_at ?? null,
    });
    const buildSupplyPayload = (order) => {
        // Ensure we always send a non-empty unit string to satisfy server validation.
        let unitName = '';
        if (order.unit_id) unitName = getUnitName(order.unit_id);
        if (!unitName && order.unit) unitName = order.unit;
        if (!unitName && order.targetId) {
            const ing = ingredientMap.get(Number(order.targetId));
            if (ing) unitName = ing.unit || getUnitName(ing.unit_id) || '';
        }
        if (!unitName) unitName = 'unité';

        const quantity = parseNumericValue(order.quantity) ?? 0;
        const purchasePrice = parseNumericValue(order.purchasePrice) ?? 0;
        const supplierId = Number(order.supplierId ?? order.supplier_id ?? order.supplierID ?? 0) || null;
        let supplier = String(order.supplier || order.supplier_name || '').trim();

        if (!supplier && supplierId) {
            const supplierItem = supplierMap.get(Number(supplierId));
            supplier = String(supplierItem?.companyName || supplierItem?.company_name || supplierItem?.name || '').trim();
        }

        const rawService = String(order.service ?? '').trim();

        return {
            itemType: order.itemType || order.item_type || (Number(order.targetId ?? order.target_id) > 0 ? 'ingredient' : 'dish'),
            service: rawService || null,
            targetId: Number(order.targetId ?? order.target_id) > 0 ? Number(order.targetId ?? order.target_id) : null,
            itemName: String(order.itemName || '').trim(),
            lotNumber: order.lotNumber ?? order.lot_number ?? null,
            reference: order.reference ?? order.reference_number ?? null,
            quantity,
            receivedQuantity: order.receivedQuantity ?? order.received_quantity ?? null,
            unit: unitName.trim(),
            purchasePrice,
            supplier,
            supplierId,
            orderDate: order.orderDate || null,
            purchaseDate: order.purchaseDate || null,
            expectedDeliveryDate: order.expectedDeliveryDate || null,
            actualDeliveryDate: order.actualDeliveryDate || null,
            perishable: order.perishable ?? false,
            expirationDate: order.expirationDate || null,
            status: normalizeSupplyStatus(order.status || 'commandé'),
            validatedByUserId: order.validatedByUserId ?? order.validated_by_user_id ?? null,
            validatedAt: order.validatedAt ?? order.validated_at ?? null,
        };
    };

    const createStockOutput = async (payload) => {
        const response = await fetchJson('/api/inventory/stock-outputs', {
            method: 'POST',
            body: JSON.stringify(payload),
        });

        await loadAppData();
        return response;
    };

    const saveStockAdjustment = async (adjustment) => {
        const payload = {
            item_type: adjustment.itemType,
            item_id: Number(adjustment.itemId),
            movement_type: adjustment.movementType,
            quantity: Number(adjustment.quantity),
            notes: adjustment.notes || null,
            movement_date: adjustment.movementDate || null,
            reference: adjustment.reference || null,
        };

        const response = await fetchJson('/api/inventory/adjustments', {
            method: 'POST',
            body: JSON.stringify(payload),
        });

        await loadAppData();
        return response;
    };

    const saveSupplyOrder = async (order) => {
        const payload = buildSupplyPayload(order);

        if (order.id) {
            const updatedOrder = await fetchJson(`/api/supply/orders/${order.id}`, {
                method: 'PUT',
                body: JSON.stringify(payload),
            });
            const normalized = normalizeSupplyOrder(updatedOrder);
            await loadAppData();
            return normalized;
        }

        const createdOrder = await fetchJson('/api/supply/orders', {
            method: 'POST',
            body: JSON.stringify(payload),
        });

        const normalized = normalizeSupplyOrder(createdOrder);
        await loadAppData();
        return normalized;
    };

    const updateSupplyOrder = async (orderId, changes) => {
        const existingOrder = supplyOrders.find((item) => item.id === orderId) || {};
        const updatedOrderData = { ...existingOrder, ...changes, id: orderId };
        const payload = buildSupplyPayload(updatedOrderData);
        const updatedOrder = await fetchJson(`/api/supply/orders/${orderId}`, {
            method: 'PUT',
            body: JSON.stringify(payload),
        });

        const normalized = normalizeSupplyOrder(updatedOrder);
        await loadAppData();
        return normalized;
    };

    const receiveSupplyLine = async (orderId, data) => {
        const updatedOrder = await fetchJson(`/api/supply/orders/${orderId}/receive`, {
            method: 'POST',
            body: JSON.stringify(data),
        });

        const normalized = normalizeSupplyOrder(updatedOrder);
        await loadAppData();
        return normalized;
    };

    const deleteSupplyOrder = async (orderId) => {
        await fetchJson(`/api/supply/orders/${orderId}`, {
            method: 'DELETE',
        });
        await loadAppData();
    };

    const saveIngredient = async (ingredient) => {
        const supplierName = ingredient.supplier?.trim() || '';
        if (supplierName) {
            await createSupplier(supplierName);
        }

        const payload = {
            name: ingredient.name,
            description: ingredient.description || '',
            marque: ingredient.marque || '',
            caracteristique: ingredient.caracteristique || '',
            supplier: supplierName || null,
            unit_id: ingredient.unit_id,
            stock_quantity: ingredient.stock,
            min_stock_alert: ingredient.threshold,
            cost_per_unit: ingredient.purchasePrice,
            category: ingredient.category || null,
            is_active: ingredient.is_active ?? true,
        };

        // Include ingredient compositions (children) when provided
        if (Array.isArray(ingredient.compositions) && ingredient.compositions.length > 0) {
            payload.compositions = ingredient.compositions.map((c) => ({
                child_ingredient_id: c.child_ingredient_id ?? c.child_id ?? c.id ?? c.ingredient_id ?? c.ingredientId,
                quantity: c.quantity,
                unit_id: c.unit_id ?? c.unitId ?? null,
                notes: c.notes ?? null,
            }));
        }

        let response;
        try {
            console.debug('saveIngredient payload:', payload, 'id:', ingredient.id);
            if (ingredient.id) {
                response = await fetchJson(`/api/inventory/ingredients/${ingredient.id}`, {
                    method: 'PUT',
                    body: JSON.stringify(payload),
                });
            } else {
                response = await fetchJson('/api/inventory/ingredients', {
                    method: 'POST',
                    body: JSON.stringify(payload),
                });
            }
            console.debug('saveIngredient response:', response);
        } catch (error) {
            console.error('Erreur lors de saveIngredient:', error);
            throw error;
        }

        const normalizedIngredient = {
            ...response,
            unit: response.unit?.name || 'unité',
            unit_id: response.unit?.id || response.unit_id,
            stock: Number(response.calculated_stock ?? response.stock_quantity ?? 0),
            threshold: Number(response.min_stock_alert || 0),
            purchasePrice: Number(response.cost_per_unit || 0),
            supplier: response.supplier || supplierName || '',
            purchaseDate: response.purchase_date || '',
            perishable: response.perishable ?? false,
            expirationDate: response.expiration_date || '',
        };

        setIngredients((prev) =>
            prev.some((item) => item.id === normalizedIngredient.id)
                ? prev.map((item) => (item.id === normalizedIngredient.id ? normalizedIngredient : item))
                : [...prev, normalizedIngredient]
        );
        // Reload to ensure consistency with server
        setTimeout(() => {
            fetchJson('/api/inventory/ingredients')
                .then((response) => {
                    const normalizedIngredients = ensureArray(response)
                        .map(normalizeIngredient)
                        .filter((item) => item.item_type !== 'consumable');
                    setIngredients(normalizedIngredients);
                })
                .catch(error => console.error('Erreur rechargement ingrédients:', error));
        }, 100);
    };

    const confirmDelete = (message) => {
        return window.confirm(message);
    };

    const saveConsumable = async (consumable) => {
        const payload = {
            name: consumable.name,
            description: consumable.description || '',
            unit_id: consumable.unit_id,
            stock_quantity: consumable.stock,
            min_stock_alert: consumable.threshold,
            cost_per_unit: consumable.purchasePrice,
            category: consumable.category || null,
            is_active: consumable.is_active ?? true,
        };

        let response;
        if (consumable.id) {
            response = await fetchJson(`/api/inventory/consumables/${consumable.id}`, {
                method: 'PUT',
                body: JSON.stringify(payload),
            });
        } else {
            response = await fetchJson('/api/inventory/consumables', {
                method: 'POST',
                body: JSON.stringify(payload),
            });
        }

        const normalizedConsumable = {
            ...response,
            id: response.id,
            name: response.name,
            description: response.description || '',
            stock: Number(response.stock ?? response.stock_quantity ?? 0),
            threshold: Number(response.threshold ?? response.min_stock_alert ?? 0),
            purchasePrice: Number(response.purchasePrice ?? response.cost_per_unit ?? 0),
            unit: response.unit || null,
            unit_id: response.unit_id,
            category: response.category || '',
            is_active: response.is_active ?? true,
        };

        setConsumables((prev) => prev.some((item) => item.id === normalizedConsumable.id)
            ? prev.map((item) => (item.id === normalizedConsumable.id ? normalizedConsumable : item))
            : [...prev, normalizedConsumable]);

        setTimeout(() => {
            fetchJson('/api/inventory/consumables')
                .then((res) => setConsumables(ensureArray(res)))
                .catch((error) => console.error('Erreur rechargement consommables:', error));
        }, 100);
    };

    const deleteConsumable = async (consumable) => {
        const consumableId = consumable?.id ?? consumable;
        if (!confirmDelete('Êtes-vous sûr de vouloir supprimer ce consommable ?')) return;
        await fetchJson(`/api/inventory/consumables/${consumableId}`, { method: 'DELETE' });
        setConsumables((prev) => prev.filter((item) => item.id !== consumableId));
        setTimeout(() => {
            fetchJson('/api/inventory/consumables')
                .then((res) => setConsumables(ensureArray(res)))
                .catch((error) => console.error('Erreur rechargement consommables:', error));
        }, 100);
    };

    const deleteIngredient = async (ingredient) => {
        const ingredientId = ingredient?.id ?? ingredient;
        if (!confirmDelete('Êtes-vous sûr de vouloir supprimer cet ingrédient ?')) return;
        await fetchJson(`/api/inventory/ingredients/${ingredientId}`, { method: 'DELETE' });
        setIngredients((prev) => prev.filter((item) => item.id !== ingredientId));
        // Reload to ensure consistency
        setTimeout(() => {
            fetchJson('/api/inventory/ingredients')
                .then((response) => {
                    const normalizedIngredients = ensureArray(response)
                        .map(normalizeIngredient)
                        .filter((item) => item.item_type !== 'consumable');
                    setIngredients(normalizedIngredients);
                })
                .catch(error => console.error('Erreur rechargement ingrédients:', error));
        }, 100);
    };

    const saveMenuItem = async (menuItem) => {
        const recipeLines = Array.isArray(menuItem.recipe)
            ? menuItem.recipe
            : (Array.isArray(menuItem.ingredients) ? menuItem.ingredients : []);

        const payload = {
            name: menuItem.name,
            description: menuItem.description || '',
            number: menuItem.number ?? null,
            dish_category_id: menuItem.dish_category_id ?? null,
            price: Number(menuItem.price) || 0,
            material_cost: Number(menuItem.material_cost) || 0,
            labor_charges: Number(menuItem.labor_charges) || 0,
            // components removed; dishes are ingredient-only
            is_component: false,
            preparation_time: menuItem.preparation_time || null,
            is_active: menuItem.is_active ?? true,
            ingredients: recipeLines.map((line) => {
                const itemId = Number(line.componentId ?? line.component_id ?? line.ingredientId ?? line.ingredient_id ?? line.id ?? 0);
                const quantity = Number(line.quantity ?? line.qty ?? 0);
                const unitId = Number(line.unitId ?? line.unit_id ?? 0) || null;

                return {
                    type: line.type === 'component' ? 'component' : line.type === 'decoration' ? 'decoration' : 'ingredient',
                    id: itemId,
                    componentId: line.type === 'component' ? itemId : null,
                    quantity,
                    unit_id: unitId,
                    notes: line.notes || '',
                };
            }).filter((line) => line.id > 0 && line.quantity > 0),
        };

            try {
            const url = menuItem.id ? `/api/inventory/dishes/${menuItem.id}` : '/api/inventory/dishes';
            const method = menuItem.id ? 'PUT' : 'POST';
            console.log('App.saveMenuItem: sending', method, url, payload);
            if (Array.isArray(payload.ingredients)) {
                console.log('App.saveMenuItem: payload.ingredients count', payload.ingredients.length, payload.ingredients);
            } else {
                console.log('App.saveMenuItem: no ingredients key in payload');
            }
            const response = await fetchJson(url, {
                method,
                body: JSON.stringify(payload),
            });

            console.log('App.saveMenuItem: server response', response);

            const toRecipeLine = (line) => {
                if (!line) return null;
                const type = line.type
                    || line.source_type
                    || (line.component || line.component_id ? 'component' : 'ingredient');

                const componentId = Number(line.component?.id || line.component_id || line.component || 0);
                const ingredientId = Number(line.ingredient?.id || line.ingredient_id || line.id || 0);

                if (line.pivot) {
                    return {
                        ingredientId: type === 'component' ? null : ingredientId,
                        componentId: type === 'component' ? componentId : null,
                        type,
                        qty: Number(line.pivot.quantity || line.quantity || 0),
                        unitId: line.pivot.unit_id || line.unit_id || null,
                        notes: line.pivot.notes || line.notes || '',
                    };
                }

                return {
                    ingredientId: type === 'component' ? null : ingredientId,
                    componentId: type === 'component' ? componentId : null,
                    type,
                    qty: Number(line.quantity || line.qty || 0),
                    unitId: line.unit_id || line.unitId || null,
                    notes: line.notes || '',
                };
            };

            const recipeSource = response.dishIngredients || response.dish_ingredients || response.ingredients || [];
            let normalizedRecipe = (Array.isArray(recipeSource) ? recipeSource : []).map(toRecipeLine).filter(Boolean);

            // If the server didn't return ingredient lines, fall back to the payload we just sent
            if ((!normalizedRecipe || normalizedRecipe.length === 0)) {
                if (Array.isArray(payload.ingredients) && payload.ingredients.length > 0) {
                    normalizedRecipe = payload.ingredients.map((line) => ({
                        ingredientId: line.type === 'component' ? null : Number(line.id || 0),
                        componentId: line.type === 'component' ? Number((line.componentId ?? line.id) || 0) : null,
                        type: line.type || 'ingredient',
                        qty: Number(line.quantity || line.qty || 0),
                        unitId: line.unit_id || line.unitId || null,
                        notes: line.notes || '',
                    }));
                } else if (Array.isArray(menuItem.recipe) && menuItem.recipe.length > 0) {
                    normalizedRecipe = (menuItem.recipe || []).map((line) => ({
                        ingredientId: line.type === 'component' ? null : Number(line.ingredientId ?? line.ingredient_id ?? line.id ?? 0),
                        componentId: line.type === 'component' ? Number(line.componentId ?? line.component_id ?? line.ingredientId ?? line.id ?? 0) : null,
                        type: line.type || 'ingredient',
                        qty: Number(line.qty ?? line.quantity ?? 0),
                        unitId: line.unitId ?? line.unit_id ?? null,
                        notes: line.notes || '',
                    }));
                }
            }

            const normalizedDish = {
                id: response?.id ?? menuItem.id ?? `temp-${Date.now()}`,
                name: response?.name || menuItem.name || 'Plat',
                number: response?.number ?? menuItem.number ?? null,
                category: response?.category?.name || response?.dish_category?.name || response?.dishCategory?.name || menuItem.category || null,
                dish_category_id: response?.dish_category_id || response?.dishCategory?.id || menuItem.dish_category_id || null,
                price: Number(response?.price || menuItem.price || 0),
                material_cost: Number(response?.material_cost || response?.materialCost || menuItem.material_cost || 0),
                labor_charges: Number(response?.labor_charges || response?.laborCharges || menuItem.labor_charges || 0),
                // components removed; dishes are ingredient-only
                is_component: false,
                recipe: normalizedRecipe,
                description: response?.description || menuItem.description || '',
                preparation_time: response?.preparation_time || menuItem.preparation_time || null,
                is_active: response?.is_active ?? menuItem.is_active ?? true,
            };

            setMenuItems((prev) => {
                if (menuItem.id) {
                    return prev.map((item) => (item.id === menuItem.id ? normalizedDish : item));
                }

                return prev.some((item) => item.id === normalizedDish.id)
                    ? prev.map((item) => (item.id === normalizedDish.id ? normalizedDish : item))
                    : [...prev, normalizedDish];
            });
        } catch (error) {
            console.error('Erreur lors de la sauvegarde du plat:', error);
            alert('Erreur lors de la sauvegarde du plat');
        }
    };

    const deleteMenuItem = async (menuItemId) => {
        if (!confirmDelete('Êtes-vous sûr de vouloir supprimer ce plat ?')) return;
        try {
            await fetchJson(`/api/inventory/dishes/${menuItemId}`, { method: 'DELETE' });
            setMenuItems((prev) => prev.filter((item) => item.id !== menuItemId));
            // Reload to ensure consistency
            setTimeout(() => {
                fetchJson('/api/inventory/dishes')
                    .then(response => setMenuItems(ensureArray(response).map(normalizeDish)))
                    .catch(error => console.error('Erreur rechargement plats:', error));
            }, 100);
        } catch (error) {
            console.error('Erreur lors de la suppression du plat:', error);
            alert('Erreur lors de la suppression du plat');
        }
    };

    const saveUnit = async (unit) => {
        const payload = {
            name: unit.name,
            abbreviation: unit.abbreviation || '',
            type: unit.type || '',
            is_active: unit.is_active ?? true,
        };

        const response = await fetchJson(unit.id ? `/api/inventory/units/${unit.id}` : '/api/inventory/units', {
            method: unit.id ? 'PUT' : 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });

        if (response) {
            setUnits((prev) => {
                if (unit.id) {
                    return prev.map((item) => (item.id === unit.id ? response : item));
                }
                return [...prev, response];
            });
        }
    };

    const deleteUnit = async (unitId) => {
        if (!confirmDelete('Êtes-vous sûr de vouloir supprimer cette unité ?')) return;
        await fetchJson(`/api/inventory/units/${unitId}`, { method: 'DELETE' });
        setUnits((prev) => prev.filter((item) => item.id !== unitId));
    };

    const saveSupplier = async (supplier) => {
        const payload = {
            companyName: supplier.companyName || '',
            firstName: supplier.firstName || '',
            lastName: supplier.lastName || '',
            position: supplier.position || '',
            email: supplier.email || '',
            phone: supplier.phone || '',
            otherContact: supplier.otherContact || '',
            contactPerson: supplier.contactPerson || '',
            comment: supplier.comment || '',
        };

        const response = await fetchJson(supplier.id ? `/api/suppliers/${supplier.id}` : '/api/suppliers', {
            method: supplier.id ? 'PUT' : 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });

        if (response) {
            setSuppliers((prev) => {
                if (supplier.id) {
                    return prev.map((item) => (item.id === supplier.id ? response : item));
                }
                return [...prev, response];
            });
        }
    };

    const deleteSupplier = async (supplierId) => {
        if (!confirmDelete('Êtes-vous sûr de vouloir supprimer ce fournisseur ?')) return;
        await fetchJson(`/api/suppliers/${supplierId}`, { method: 'DELETE' });
        setSuppliers((prev) => prev.filter((item) => item.id !== supplierId));
    };

    const saveProductType = async (productType) => {
        const payload = {
            name: productType.name || '',
            description: productType.description || '',
            is_active: productType.is_active ?? true,
        };

        const response = await fetchJson(productType.id ? `/api/product-types/${productType.id}` : '/api/product-types', {
            method: productType.id ? 'PUT' : 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });

        if (response) {
            setProductTypes((prev) => {
                if (productType.id) {
                    return prev.map((item) => (item.id === productType.id ? response : item));
                }
                return [...prev, response];
            });
        }
    };

    const deleteProductType = async (productTypeId) => {
        if (!confirmDelete('Êtes-vous sûr de vouloir supprimer ce type de produit ?')) return;
        await fetchJson(`/api/product-types/${productTypeId}`, { method: 'DELETE' });
        setProductTypes((prev) => prev.filter((item) => item.id !== productTypeId));
    };

    const alerts = ingredients.filter((item) => item.stock <= item.threshold);

    const activeTabElement = {
        commandes: (
            <CommandesTab
                tables={tables}
                menuItems={menuItems}
                ingredients={ingredients}
                onUpdateTableOrder={updateTableOrder}
                onSendOrder={sendOrderToKitchen}
                onMarkOrderAsServed={markOrderAsServed}
                onPayOrder={payOrder}
                getPortionsRemaining={getPortionsRemaining}
                onOpenPrepareModal={(orderId) => {
                    setActiveTab('recipes');
                    // Dispatch event to recipes tab after tab switch
                    setTimeout(() => {
                        window.dispatchEvent(new CustomEvent('openPrepareModal', { detail: { orderId } }));
                    }, 150);
                }}
            />
        ),
        cuisine: (
            <CuisineTab
                tickets={tickets}
                menuItems={menuItems}
                onUpdateTicket={updateTicket}
                onConsumeTicketStock={consumeTicketStock}
            />
        ),
        parametres: (
            <ParametersTab onNavigate={setActiveTab} />
        ),
        import: (
            <ImportTab onImportSuccess={loadAppData} />
        ),
        biensCategories: (
            <BiensCategoriesTab />
        ),
        plats: (
            <PlatsMenuTab
                menuItems={menuItems}
                ingredients={ingredients}
                units={units}
                dishCategories={dishCategories}
                onSaveMenuItem={saveMenuItem}
                onDeleteMenuItem={deleteMenuItem}
                onImportSuccess={loadAppData}
                getPortionsRemaining={getPortionsRemaining}
            />
        ),
        ingredients: (
            <IngredientsTab
                ingredients={ingredients}
                units={units}
                suppliers={suppliers}
                onSaveIngredient={saveIngredient}
                onDeleteIngredient={deleteIngredient}
                onImportSuccess={loadAppData}
            />
        ),
        consumables: (
            <ConsumablesTab
                consumables={consumables}
                units={units}
                onSaveConsumable={saveConsumable}
                onDeleteConsumable={deleteConsumable}
            />
        ),
        units: (
            <UnitsTab units={units} onSaveUnit={saveUnit} onDeleteUnit={deleteUnit} />
        ),
        suppliers: (
            <SuppliersTab suppliers={suppliers} onSaveSupplier={saveSupplier} onDeleteSupplier={deleteSupplier} />
        ),
        supply: (
            <SupplyTab
                ingredients={ingredients}
                consumables={consumables}
                units={units}
                suppliers={suppliers}
                supplyOrders={supplyOrders}
                onSaveSupplyOrder={saveSupplyOrder}
                onUpdateSupplyOrder={updateSupplyOrder}
                onDeleteSupplyOrder={deleteSupplyOrder}
                onReceiveSupplyLine={receiveSupplyLine}
            />
        ),
        stock: (
            <StockTab
                menuItems={menuItems}
                ingredients={ingredients}
                movements={movements}
                alerts={alerts}
                getPortionsRemaining={getPortionsRemaining}
                supplyOrders={supplyOrders}
                suppliers={suppliers}
            />
        ),
        suppliersComparison: (
            <SuppliersComparisonTab
                items={ingredients}
                movements={movements}
                supplyOrders={supplyOrders}
                suppliers={suppliers}
            />
        ),
        stockOutput: (
            <StockOutputTab
                ingredients={ingredients}
                consumables={consumables}
                onCreateStockOutput={createStockOutput}
            />
        ),
        stockAdjustment: (
            <StockAdjustmentTab
                ingredients={ingredients}
                consumables={consumables}
                units={units}
                movements={movements}
                onSaveStockAdjustment={saveStockAdjustment}
            />
        ),
        stockTrends: (
            <StockTrendsTab
                ingredients={ingredients}
                consumables={consumables}
                movements={movements}
            />
        ),
        dailyPayments: (
            <SalesOverviewTab user={user} />
        ),
        // components tab removed
        batches: (
            <BatchesTab />
        ),
        recipeVersions: (
            <RecipeVersionsTab />
        ),
        recipes: (
            <RecipesTab />
        ),
        ingredientInventories: (
            <IngredientInventoriesTab onInventoryChanged={loadAppData} />
        ),
        salesHistory: (
            <SalesHistoryTab />
        ),
        salesReport: (
            <SalesReportTab />
        ),
        productTypes: (
            <ProductTypesTab
                productTypes={productTypes}
                onSaveProductType={saveProductType}
                onDeleteProductType={deleteProductType}
            />
        ),
        tables: (
            <TablesTab
                tables={tables}
                setTables={setTables}
            />
        ),
        biens: (
            <BiensTab />
        ),
    }[activeTab] || (
        <div className="rounded-3xl border border-rose-400 bg-rose-50 p-8 text-rose-700">
            <h2 className="text-xl font-semibold">Onglet introuvable</h2>
            <p className="mt-2 text-sm text-rose-600">
                L’onglet demandé n’est pas disponible. Veuillez ouvrir le menu et sélectionner un onglet valide.
            </p>
        </div>
    );

    const activeTabLabel =
        tabs.find((t) => t.key === activeTab)?.label
        || parameterSubTabs.find((t) => t.key === activeTab)?.label
        || '';

    return (
        // Fond général : crème chaude du moodboard
        <div className="h-screen w-screen overflow-hidden flex flex-col font-gilroy" style={{ background: '#FCECD1' }}>

            {/* ── Header ── couleur principale #163B16 */}
            <header className="flex-shrink-0 shadow-lg z-50" style={{ background: '#163B16' }}>
                <div className="h-full flex items-center justify-between px-3 sm:px-6 py-3 gap-3">
                    <div className="flex items-center gap-2 sm:gap-4 min-w-0">
                        {/* Bouton menu — visible uniquement quand la barre latérale est masquée
                            (mobile/tablette, ou desktop si l'utilisateur l'a repliée) */}
                        <button
                            type="button"
                            onClick={() => setSidebarOpen((prev) => !prev)}
                            aria-label={sidebarOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
                            className="flex-shrink-0 rounded-lg p-2 text-[#FCECD1] hover:bg-white/10 transition"
                        >
                            {sidebarOpen ? (
                                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                                    <path d="M6 6l12 12M18 6L6 18" />
                                </svg>
                            ) : (
                                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                                    <path d="M4 7h16M4 12h16M4 17h16" />
                                </svg>
                            )}
                        </button>
                        <img src="/images/logo.png" alt="Logo" className="h-10 sm:h-15 flex-shrink-0" />
                        {/* Sur mobile, on affiche le nom de l'onglet actif à côté du logo */}
                        <span
                            className="hidden sm:block lg:hidden text-sm font-semibold truncate"
                            style={{ color: '#FCECD1' }}
                        >
                            {activeTabLabel}
                        </span>
                    </div>

                    {/* Badge header : vert légèrement plus clair */}
                    <div
                        className="rounded-2xl px-2 sm:px-3 py-2 text-sm shadow-lg flex items-center gap-2 sm:gap-3 flex-shrink-0"
                        style={{ background: 'rgba(252,236,209,0.10)', border: '1px solid rgba(252,236,209,0.18)' }}
                    >
                        <div className="hidden sm:block text-right">
                            <p className="font-semibold" style={{ color: '#FCECD1' }}>
                                {user ? user.name : 'Utilisateur'}
                            </p>
                            <p style={{ color: '#8b6341' }}>
                                {user?.role?.label || user?.role?.name || 'Rôle inconnu'}
                            </p>
                        </div>
                        <button
                            type="button"
                            onClick={() => {
                                setRefreshing(true);
                                loadAppData().finally(() => setRefreshing(false));
                            }}
                            disabled={refreshing}
                            className="rounded-full border border-white/20 bg-white/10 px-2 sm:px-3 py-2 text-xs font-semibold text-white hover:bg-white/20 disabled:opacity-60"
                        >
                            <span className="hidden sm:inline">{refreshing ? 'Actualisation…' : 'Actualiser'}</span>
                            <svg className={`w-4 h-4 sm:hidden ${refreshing ? 'animate-spin' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 12a9 9 0 1 1-2.6-6.4M21 4v5h-5" />
                            </svg>
                        </button>
                        <button
                            type="button"
                            onClick={handleLogout}
                            className="rounded-full border border-white/20 bg-white/10 px-2 sm:px-3 py-2 text-xs font-semibold text-white hover:bg-white/20"
                        >
                            <span className="hidden sm:inline">Déconnexion</span>
                            <svg className="w-4 h-4 sm:hidden" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
                            </svg>
                        </button>
                    </div>
                </div>
            </header>

            <div className="relative flex-1 min-h-0 flex">
                {/* ── Overlay mobile — referme le menu quand on clique en dehors ── */}
                {sidebarOpen && (
                    <div
                        className="fixed inset-0 bg-black/40 z-30 lg:hidden"
                        onClick={() => setSidebarOpen(false)}
                        aria-hidden="true"
                    />
                )}

                {/* ── Sidebar ── fond crème, bordure verte, tiroir sur mobile/tablette,
                    fixe et toujours visible à partir de la largeur "lg" (desktop) ── */}
                <aside
                    className={`fixed lg:sticky top-0 left-0 h-[calc(100vh-0px)] lg:h-auto w-72 max-w-[85vw] shrink-0 p-5 shadow-xl overflow-y-auto z-40 transition-transform duration-300 ease-in-out
                        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:-translate-x-full lg:hidden'}`}
                    style={{
                        background: '#FCECD1',
                        borderRight: '2px solid #163B16',
                    }}
                >
                    <div
                        className="mb-5 text-xs font-semibold uppercase tracking-wider"
                        style={{ color: '#8b6341' }}
                    >
                        Navigation
                    </div>

                    <nav className="space-y-5">
                        {visibleNavGroups.map((group) => (
                            <div key={group.label}>
                                <div
                                    className="mb-1.5 px-1 text-[11px] font-bold uppercase tracking-wider"
                                    style={{ color: '#8b6341' }}
                                >
                                    {group.label}
                                </div>
                                <div className="space-y-1">
                                    {group.tabs.map((tab) => {
                                        const isParamTab = tab.key === 'parametres';
                                        const isActive = activeTab === tab.key;
                                        return (
                                            <div key={tab.key}>
                                                <button
                                                    className="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm font-medium transition"
                                                    style={
                                                        isActive
                                                            ? { background: '#163B16', color: '#FCECD1' }
                                                            : { color: '#163B16', background: 'transparent' }
                                                    }
                                                    onMouseEnter={(e) => {
                                                        if (!isActive) e.currentTarget.style.background = 'rgba(22,59,22,0.09)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (!isActive) e.currentTarget.style.background = 'transparent';
                                                    }}
                                                    onClick={() => navigateTab(tab.key)}
                                                    aria-current={isActive ? 'page' : undefined}
                                                >
                                                    <NavIcon
                                                        name={tab.key}
                                                        className={`w-5 h-5 flex-shrink-0 ${isActive ? 'opacity-100' : 'opacity-70'}`}
                                                    />
                                                    <span className="truncate">{tab.label}</span>
                                                </button>

                                                {/* Sous-menu "Paramètres" — toujours déroulé, visuellement rattaché
                                                    grâce à un léger décalage et une bordure verte fine */}
                                                {isParamTab && (
                                                    <div
                                                        className="mt-1 ml-3 space-y-0.5 border-l-2 pl-3"
                                                        style={{ borderColor: 'rgba(22,59,22,0.25)' }}
                                                    >
                                                        {parameterSubTabs.map((sub) => {
                                                            const isSubActive = activeTab === sub.key;
                                                            return (
                                                                <button
                                                                    key={sub.key}
                                                                    className="flex w-full items-center gap-2.5 rounded-lg px-3 py-2 text-left text-[13px] font-medium transition"
                                                                    style={
                                                                        isSubActive
                                                                            ? { background: '#163B16', color: '#FCECD1' }
                                                                            : { color: '#4d3a2a', background: 'transparent' }
                                                                    }
                                                                    onClick={() => navigateTab(sub.key)}
                                                                    aria-current={isSubActive ? 'page' : undefined}
                                                                >
                                                                    <NavIcon
                                                                        name={sub.icon}
                                                                        className={`w-4 h-4 flex-shrink-0 ${isSubActive ? 'opacity-100' : 'opacity-60'}`}
                                                                    />
                                                                    <span className="truncate">{sub.label}</span>
                                                                </button>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                    </nav>

                    {/* Alertes rupture de stock — désactivées temporairement, ne pas afficher actuellement
                    {alerts.length > 0 && (
                        <div
                            className="mt-8 rounded-xl p-4"
                            style={{ background: '#fde8e8', border: '1.5px solid #f5b0b0' }}
                        >
                            <p className="font-semibold" style={{ color: '#7a2020' }}>Alertes rupture</p>
                            <ul className="mt-3 list-disc space-y-2 pl-5 text-sm" style={{ color: '#7a2020' }}>
                                {alerts.map((item) => (
                                    <li key={item.id}>
                                        {item.name} est en dessous du seuil ({item.stock} / {item.threshold})
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    */}
                </aside>

                {/* ── Contenu principal ── fond blanc neutre pour la lisibilité */}
                <main className="flex-1 min-w-0 overflow-auto" style={{ background: '#ffffff' }}>
                    <div className="p-4 sm:p-6">
                        {activeTabElement}
                    </div>
                </main>
            </div>
        </div>
    );
}

export default App;